module.exports = __webpack_public_path__ + "static/media/MenuSpecials.7f6ca442.pdf";